import React from "react";
import { ButtonProps, message } from "antd";
import { useTranslate } from "@refinedev/core";
import { signInWithRedirect } from "aws-amplify/auth";
import { TrackedButton } from "components/TrackedButton";
import { AnalyticsEvents } from "types/analytics";
import { OauthFlowAction } from "types";
import {
  clearPendingAuthMethod,
  setPendingAuthMethod,
} from "services/pendingAuthMethod";
import { serializeAttribution } from "utils/analytics";

export const GoogleLoginButton: React.FC<
  ButtonProps & { action: OauthFlowAction }
> = ({ style, action, title, ...rest }) => {
  const t = useTranslate();

  const handleGoogleLogin = async () => {
    try {
      clearPendingAuthMethod();
      setPendingAuthMethod("google");
      await signInWithRedirect({
        provider: "Google",
        customState: serializeAttribution(),
      });
    } catch (error) {
      console.error(
        t("pages.auth.errors.providerLoginError", { provider: "Google" }),
        error
      );
      if ((error as Error).name === "UserAlreadyAuthenticatedException") {
        message.error("You are already logged in");
      }
    }
  };

  return (
    <TrackedButton
      trackingEventName={AnalyticsEvents.LoginAttempt}
      trackingProps={{ login_method: "google", action }}
      type="default"
      icon={
        <img
          src="/images/logo_google_g.svg"
          alt="Google"
          style={{ width: 20, height: 20 }}
        />
      }
      onClick={handleGoogleLogin}
      style={style}
      {...rest}
    >
      {title ?? t("pages.login.googleLogin")}
    </TrackedButton>
  );
};
